﻿import Loader from '../../Components/Loader'
import VMyDatepicker from '../../Components/Shared/VMyDatepicker'
import './vue-directives'
import http from './http'

export default {
    components: { Loader, VMyDatepicker },
    data: () => ({
        $form: null,
        isBusy: false,
        isSubmit: false,
        error: {
            loading: false,
            validations: {},
            post: null
        },
        messages: {
            ok: null,
            ko: null
        },
        date: {
            value: null,
            isChecking: false,
            isOk: null
        }
    }),
    computed: {
        isStats () {
            return this.stats
        },
        dataLoaded () {
            // implementar en cada js
        },
        displayForm () {
            return this.dataLoaded && !this.isPostDone
        },
        isErrorLoading () {
            return this.error.loading
        },
        isPostDone () {
            return this.error.post !== null
        },
        isPostKo () {
            return !!this.error.post
        },
        isPostKo400 () {
            return this.isPostKo && this.messages.ko
        },
        isPostKo400Stats () {
            return this.isPostKo400 && this.isStats
        },
        isPostOk () {
            return this.error.post === false
        },
        isPostStatsOk () {
            return this.isPostOk && this.isStats
        },
        hintCheckDate () {
            return this.date.isChecking ? 'Comprobando fecha' : null
        },
        currentDate () {
            return this.date.value
        },
        checkDatePayload () {
            // implementar en cada js
        },
        hasValidationErrors () {
            return Object.keys(this.error.validations).length > 0
        }
    },
    methods: {
        startLoading () {
            this.isBusy = true
            this.error.loading = false
        },
        finishLoading () {
            this.isBusy = false
        },
        errorLoading () {
            this.error.loading = true
        },
        retryLoad () {
            setTimeout(this.load, 300)
        },
        setErrors () {
            if (!this.$form) return

            const modelState = this.$form.$el.dataset.modelState
            if (modelState)
                this.error.validations = new Function(`return ${modelState}`)()
        },
        resetError(key) {
            this.error.validations[key] = null
        },
        async post () {
            this.resetFormStatus()
            this.isSubmit = true

            try {
                const formData = new FormData(this.$refs.form.$el);
                const { data } = await http.post(this.$refs.form.$el.action, formData)
                this.postOk(data.mensaje || data)
            }
            catch (error) {
                this.managePostKo(error)
            }
            finally {
                this.isSubmit = false
            }
        },
        postOk (message) {
            this.error.post = false
            this.messages.ok = message
        },
        postKo (message) {
            this.error.post = true
            this.messages.ko = message
        },
        retry () {
            this.error.post = null  
        },
        resetFormStatus () {
            this.error.validations = {}
            this.error.post = null
            this.messages.ok = null
            this.messages.ko = null
        },
        displayMessageOk(defaultMessage) {
            return this.messages.ok || defaultMessage
        },
        displayMessageKo(defaultMessage) {
            return this.messages.ko || defaultMessage
        },
        managePostKo(error) {
            if (error.response && [400, 404].includes(error.response.status) && error.response.data) {
                if (typeof error.response.data === 'string') { this.postKo(error.response.data) }
                if (typeof error.response.data === 'object') { this.error.validations = error.response.data }
                return;
            }
            this.postKo()
        },
        setEndPoint (url) {
            this.endpoint = url || this.$form.$el.dataset.controller
        },
        async checkDate () {
            if (this.date.source) this.date.source.cancel()
            
            setTimeout(this.doCheckDate)
        },
        async doCheckDate () {
            this.date.isChecking = true

            this.resetCheckDate()

            try {
                await http.post(`${this.endpoint}/CheckDate`, this.checkDatePayload, { cancelToken: this.date.source.token })
                this.date.isOk = true
            } catch (error) {
                this.date.isOk = false
                if (error.response && error.response.status === 400)
                    this.error.validations.Fecha = [error.response.data]
            } finally {
                this.date.isChecking = false
            }
        },
        resetCheckDate () {
            this.date.isOk = null
            this.error.validations.Fecha = []
            this.date.source = http.CancelToken.source()
        }
    },
    mounted () {
        this.$form = this.$refs.form
        this.setErrors()
    }
}